export default {"src":"/app/_next/static/media/handshake.08093c8e.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};